export default {
  // async
  // SET_TABLE: 'SET_TABLE',
  // SET_LEGENDA: 'SET_LEGENDA',
  SET_POSTFLOP_SITUATION: 'SET_POSTFLOP_SITUATION',
  SET_POSTFLOP_SIMILAR: 'SET_POSTFLOP_SIMILAR',
  GET_COMBO: 'GET_COMBO',
  GET_NEXT_COMBO: 'GET_NEXT_COMBO',
  // // fetches black cells with only fold
  // SET_FIRST_PAIR: 'SET_FIRST_PAIR',
  // SET_SECOND_PAIR: 'SET_SECOND_PAIR',
  // SET_PURPLE: 'SET_PURPLE',

  // sync
  SET_DEFAULT: 'SET_DEFAULT',
  SET_TABLE_SIZE: 'SET_TABLE_SIZE',
  SET_STACK_SIZE: 'SET_STACK_SIZE',
  SET_POSITION_TYPE: 'SET_POSITION_TYPE',
  SET_POSITION: 'SET_POSITION',
  SET_RESULTS_POSITION_TYPE: 'SET_RESULTS_POSITION_TYPE',
  SET_RESULTS_PFR_TYPE: 'SET_RESULTS_PFR_TYPE',
  SET_RESULTS_PLAYER_POSITION: 'SET_RESULTS_PLAYER_POSITION',
  SET_RESULTS_POSITION: 'SET_RESULTS_POSITION',
  SET_RESULTS_PREVIOUS_ACTION: 'SET_RESULTS_PREVIOUS_ACTION',
  SET_BOARD_SUIT: 'SET_BOARD_SUIT',
  SET_BOARD_TYPE: 'SET_BOARD_TYPE',
  SET_SELECTED_BOARD: 'SET_SELECTED_BOARD',
  SET_SELECTED_CARDS: 'SET_SELECTED_CARDS',
  SET_BOARD_SITUATION: 'SET_BOARD_SITUATION',
  SET_COMBO: 'SET_COMBO',
  CLEAR_NEXT_COMBO: 'CLEAR_NEXT_COMBO',
  GET_POSTFLOP_RESULTS_STAT: 'GET_POSTFLOP_RESULTS_STAT',
  SET_SEARCH_VALUE: 'SET_SEARCH_VALUE',
  SET_SIMILAR_RESPONSE: 'SET_SIMILAR_RESPONSE',
  SET_SELECTED_HIGH_CARD: 'SET_SELECTED_HIGH_CARD',
  SET_SELECTED_HAND_TYPE: 'SET_SELECTED_HAND_TYPE',
  SET_HIGH_LOW: 'SET_HIGH_LOW',
  SET_PAGE_MODE: 'SET_PAGE_MODE',
  SET_GAME_STARTED: 'SET_GAME_STARTED',
};
